import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { MemberService } from '@services/member.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '@services/api.service';
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.sass']
})
export class LogoutComponent implements OnInit {

  constructor(private _apiService: ApiService, private route: ActivatedRoute, private _global: GlobalService, private router: Router, private _memberService: MemberService) {
    this._memberService.logout({}).subscribe(
     data => {
       localStorage.removeItem(this._global.SESSION_KEY);

       this._apiService.getMemberSession().subscribe(
         memberSession => {
           let response = this._global.getVal(memberSession, 'response', '');
           if (response != null && response != undefined && (response != '' || response != {})) {
             localStorage.removeItem(this._global.SESSION_KEY);
             localStorage.setItem(this._global.SESSION_KEY, JSON.stringify(response));
             this.router.navigate(['']);
           }
           else {
             console.log("ERROR : memberSession :", memberSession);
           }
         },
         error => {
           console.log("Subscription error:", error);
           this._apiService.handleError(error);
         }
       );

     },
     error => {
       // localStorage.removeItem(this._global.SESSION_KEY);
       console.log("error", JSON.stringify(error));
       this.router.navigate(['']);
     }); 
 }

 ngOnInit() {
 }

}
